/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_SummaryInputs */

const en_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better shots result from efficient motion, which also lessens lifelong physical strain and injury`)
};

const es_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los mejores golpes surgen de un movimiento eficiente, que además reduce la carga física y las lesiones a lo largo de la vida`)
};

const de_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bessere Schläge entstehen durch effiziente Bewegung, die zugleich lebenslange körperliche Belastung und Verletzungen verringert`)
};

const zh_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高效的动作带来更好的击球，也能减少一生中的身体负担和伤病`)
};

const ar_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنتج الضربات الأفضل من حركة فعّالة تقلل أيضاً الإجهاد البدني وخطر الإصابة على مدى الحياة.`)
};

const fr_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De meilleurs coups naissent d'un mouvement efficace, qui réduit aussi les contraintes physiques et les blessures tout au long de la vie`)
};

const vi_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cú đánh tốt hơn đến từ chuyển động hiệu quả, cũng giảm căng vật lý và chấn thương suốt đời`)
};

const sw_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mipigo bora hutokana na mwendo wenye ufanisi, ambao pia hupunguza mkazo wa mwili na majeraha maishani`)
};

const th_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช็อตที่ดีขึ้นมาจากการเคลื่อนไหวที่มีประสิทธิภาพ ซึ่งยังช่วยลดภาระทางกายและการบาดเจ็บตลอดชีวิต`)
};

const bs_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolji udarci proizlaze iz efikasnog pokreta, koji također smanjuje doživotni fizički napor i povrede`)
};

const ja_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`効率的な動きから良いショットが生まれ、生涯にわたる身体への負担やケガも減ります。`)
};

const ko_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`효율적인 동작에서 더 좋은 샷이 나오며, 평생에 걸친 신체 부담과 부상도 줄어듭니다`)
};

const pt_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tacadas melhores resultam de um movimento eficiente, que também reduz o desgaste físico e as lesões ao longo da vida`)
};

const it_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colpi migliori nascono da un movimento efficiente, che riduce anche l'affaticamento fisico e il rischio di infortuni nel corso della vita`)
};

const sv_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bättre slag kommer av effektiv rörelse, som också minskar livslång fysisk belastning och skaderisk`)
};

const nl_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betere slagen ontstaan door efficiënte beweging, die ook levenslange fysieke belasting en blessures vermindert`)
};

const da_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedre slag kommer af effektiv bevægelse, som også mindsker livslang fysisk belastning og skaderisiko`)
};

const nb_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedre slag kommer av effektiv bevegelse, som også reduserer livslang fysisk belastning og skaderisiko`)
};

const fi_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paremmat lyönnit syntyvät tehokkaasta liikkeestä, joka myös vähentää elinikäistä fyysistä rasitusta ja loukkaantumisia`)
};

const pl_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepsze uderzenia wynikają z efektywnego ruchu, który także zmniejsza dożywotnie obciążenie fizyczne i ryzyko kontuzji`)
};

const ru_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие удары рождаются из эффективного движения, которое также снижает пожизненную физическую нагрузку и риск травм`)
};

const tr_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha iyi vuruşlar verimli hareketten doğar; bu hareket ömür boyu fiziksel yükü ve sakatlanma riskini de azaltır`)
};

const hi_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुशल गति से बेहतर शॉट्स मिलते हैं, जिससे जीवन भर का शारीरिक तनाव और चोट का जोखिम भी कम होता है`)
};

const id_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pukulan yang lebih baik lahir dari gerakan yang efisien, yang juga mengurangi beban fisik dan cedera seumur hidup`)
};

const ms_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pukulan yang lebih baik terhasil daripada gerakan yang cekap, yang turut mengurangkan tekanan fizikal dan kecederaan sepanjang hayat`)
};

const cs_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepší údery vznikají z efektivního pohybu, který také snižuje celoživotní fyzickou zátěž a riziko zranění`)
};

const el_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καλύτερα χτυπήματα προκύπτουν από αποδοτική κίνηση, που μειώνει επίσης τη δια βίου σωματική καταπόνηση και τον κίνδυνο τραυματισμού`)
};

const he_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבטות טובות יותר נובעות מתנועה יעילה, שמפחיתה גם את העומס הגופני ואת הסיכון לפציעה לאורך החיים`)
};

const af_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beter houe kom van doeltreffende beweging, wat ook lewenslange fisieke spanning en beserings verminder`)
};

const hu_method_content_step_06_summary = /** @type {(inputs: Method_Content_Step_06_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A jobb ütések hatékony mozgásból születnek, amely egyúttal csökkenti az egész életen át tartó fizikai terhelést és a sérüléseket`)
};

/**
* | output |
* | --- |
* | "Better shots result from efficient motion, which also lessens lifelong physical strain and injury" |
*
* @param {Method_Content_Step_06_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_summary = /** @type {((inputs?: Method_Content_Step_06_SummaryInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_SummaryInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_summary(inputs)
	if (locale === "de") return de_method_content_step_06_summary(inputs)
	if (locale === "zh") return zh_method_content_step_06_summary(inputs)
	if (locale === "ar") return ar_method_content_step_06_summary(inputs)
	if (locale === "fr") return fr_method_content_step_06_summary(inputs)
	if (locale === "vi") return vi_method_content_step_06_summary(inputs)
	if (locale === "sw") return sw_method_content_step_06_summary(inputs)
	if (locale === "th") return th_method_content_step_06_summary(inputs)
	if (locale === "bs") return bs_method_content_step_06_summary(inputs)
	if (locale === "ja") return ja_method_content_step_06_summary(inputs)
	if (locale === "ko") return ko_method_content_step_06_summary(inputs)
	if (locale === "pt") return pt_method_content_step_06_summary(inputs)
	if (locale === "it") return it_method_content_step_06_summary(inputs)
	if (locale === "sv") return sv_method_content_step_06_summary(inputs)
	if (locale === "nl") return nl_method_content_step_06_summary(inputs)
	if (locale === "da") return da_method_content_step_06_summary(inputs)
	if (locale === "nb") return nb_method_content_step_06_summary(inputs)
	if (locale === "fi") return fi_method_content_step_06_summary(inputs)
	if (locale === "pl") return pl_method_content_step_06_summary(inputs)
	if (locale === "ru") return ru_method_content_step_06_summary(inputs)
	if (locale === "tr") return tr_method_content_step_06_summary(inputs)
	if (locale === "hi") return hi_method_content_step_06_summary(inputs)
	if (locale === "id") return id_method_content_step_06_summary(inputs)
	if (locale === "ms") return ms_method_content_step_06_summary(inputs)
	if (locale === "cs") return cs_method_content_step_06_summary(inputs)
	if (locale === "el") return el_method_content_step_06_summary(inputs)
	if (locale === "he") return he_method_content_step_06_summary(inputs)
	if (locale === "af") return af_method_content_step_06_summary(inputs)
	if (locale === "hu") return hu_method_content_step_06_summary(inputs)
	return en_method_content_step_06_summary(inputs)
});